export default __webpack_public_path__ + "static/media/darkmode-editPassword.1fc86b4d.svg";